import React, { useState, useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "./quotationMaker.css";
import PBQuot from "./PBQuot.jsx";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { SiReact } from 'react-icons/si';
import { FiPrinter, FiDownload, FiSave, FiCalendar, FiMapPin, FiUser, FiMail, FiPhone, FiSmartphone, FiHome } from "react-icons/fi";



function QuotationMaker() {
 
  const [activeTab, setActiveTab] = useState("details");
  const [showQuotation, setShowQuotation] = useState(false);
  const componentRef = useRef();

  // Package options configuration
  const initialPackageOptions = {
    "Basic Package": [
      "Main photoshoot at preferred location (Two camera coverage)",
      "Wedding ceremony and reception",
      "2 enlargement 16x24 (with frame)",
      "2 enlargement 12x18 (with frame)",
      "Photobook Albums 12x30 or 16x24 (Magazine type 50 pages)",
      "100 Thanking card 6x8 (one side)",
      "Digital album",
      "10 Edited images for social media",
      "Wedding day all photos soft copies free",
      "Colombo area transport free",
      "Videography",
    ],
    "Standard Package": [
      "Main photoshoot at preferred location (Two camera coverage)",
      "Wedding ceremony and reception",
      "2 enlargement 20x30 (with frame)",
      "2 enlargement 16x24 (with frame)",
      "Photobook Albums 12x30 or 16x24 (Story type 50 pages)",
      "150 Thanking card 6x8 (one side)",
      "Digital album",
      "10 high-end edited images for social media",
      "Wedding day all photos soft copies free",
      "Colombo area transport free",
      "Videography",
    ],
    "Premium Package": [
      "Main photoshoot at preferred location (Two camera coverage)",
      "Wedding ceremony and reception (Two camera coverage)",
      "2 enlargement 20x30 (with frame)",
      "2 enlargement 16x24 (with frame)",
      "2 enlargement 12x18 (with frame)",
      "Photobook Albums 12x34 or 17x24 (Magazine type TAB album 60 pages)",
      "150 Thanking card 6x8 (double side)",
      "Digital album",
      "15 high-end edited images for social media",
      "Wedding day all photos soft copies free",
      "Colombo area transport free",
      "Videography",
    ]
  };

  // Form state
  const [formData, setFormData] = useState({
    customerName: "",
    address: "",
    telephoneNo: "",
    mobileNo: "",
    email: "",
    weddingDate: "",
    WeddingLocation: "",
    homecomingDate: "",
    homecomingLocation: "",
    preshootDate: "",
    preshootLocation: "",
    packageSelected: "Basic Package",
    editablePackages: JSON.parse(JSON.stringify(initialPackageOptions)),
    packageOptions: {},
    additionalDetails: "",
    homecomingOptions: {
      shootOnly: false,
      shootFunction: false,
      discount: '',
  payments: [
  { amount: '', date: '', description: '', received: false, active: true } // Initial payment part
  ]
    },
    photographySetup: {
      camera1: false,
      camera2: false
    },
    cinematographySetup: {
      camera1: false,
      camera2: false,
      drone: false
    },
    preshootSetup: {
      camera1: false,
      camera2: false,
      drone: false
    },
    
    total: "",
    advance: "",
     advanceDate: '',
    quotationNumber: "",
    status: "pending"
  });


  useEffect(() => {
  const quotationToEdit = localStorage.getItem('quotationToEdit');
  if (quotationToEdit) {
    try {
      const parsedQuotation = JSON.parse(quotationToEdit);
      
      // Ensure editablePackages exists and has proper structure
      const editablePackages = parsedQuotation.editablePackages || JSON.parse(JSON.stringify(initialPackageOptions));
      
      setFormData({
        customerName: parsedQuotation.customerName || "",
        address: parsedQuotation.address || "",
        telephoneNo: parsedQuotation.telephoneNo || "",
        mobileNo: parsedQuotation.mobileNo || "",
        email: parsedQuotation.email || "",
        weddingDate: parsedQuotation.weddingDate || "",
        WeddingLocation: parsedQuotation.WeddingLocation || "",
        homecomingDate: parsedQuotation.homecomingDate || "",
        homecomingLocation: parsedQuotation.homecomingLocation || "",
        preshootDate: parsedQuotation.preshootDate || "",
        preshootLocation: parsedQuotation.preshootLocation || "",
        packageSelected: parsedQuotation.packageSelected || "Basic Package",
        editablePackages: editablePackages,
        packageOptions: parsedQuotation.packageOptions || {},
        additionalDetails: parsedQuotation.additionalDetails || "",
        homecomingOptions: parsedQuotation.homecomingOptions || {
          shootOnly: false,
          shootFunction: false,
        },
        payments: parsedQuotation.payments || [
          { amount: '', date: '', description: '', received: false }
        ],
        photographySetup: parsedQuotation.photographySetup || {
          camera1: false,
          camera2: false
        },
        cinematographySetup: parsedQuotation.cinematographySetup || {
          camera1: false,
          camera2: false,
          drone: false
        },
        preshootSetup: parsedQuotation.preshootSetup || {
          camera1: false,
          camera2: false,
          drone: false
        },
        total: parsedQuotation.total || "",
        advance: parsedQuotation.advance || "",
        advanceDate: parsedQuotation.advanceDate || '',
        discount: parsedQuotation.discount || "",
        quotationNumber: parsedQuotation.quotationNumber || "",
        status: parsedQuotation.status || "pending"
      });
      
      // Clear the stored quotation after loading
      localStorage.removeItem('quotationToEdit');
      
      // Show the quotation preview if needed
      setShowQuotation(true);
    } catch (error) {
      console.error("Error loading quotation data:", error);
    }
  }
}, []);


// Replace your getNextQuotationNumber function with this:
const handleSaveToServer = async () => {
  try {
    // Check if we're editing an existing quotation
    const isEdit = !!formData.quotationNumber;
    
    // Prepare save data
    let saveData = {
      ...formData,
      balance: calculateBalance(),
      status: "pending",
      updatedAt: new Date().toISOString(),
      // Always include filename for both new and existing
      filename: formData.quotationNumber ? `quotation_${formData.quotationNumber}.json` : null
    };

    // If it's a new quotation, get a new number first
    if (!isEdit) {
      const numberResponse = await fetch('http://priyanthabandara.lk/generate_quotation_number.php');
      if (!numberResponse.ok) {
        const errorData = await numberResponse.json().catch(() => ({}));
        throw new Error(errorData.error || 'Failed to get quotation number');
      }
      
      const numberResult = await numberResponse.json();
      if (!numberResult.success) {
        throw new Error(numberResult.error || 'Number generation failed');
      }
      
      saveData.quotationNumber = numberResult.quotationNumber;
      saveData.createdAt = new Date().toISOString();
      saveData.filename = `quotation_${saveData.quotationNumber}.json`;
    }

    // Determine the endpoint
    const endpoint = isEdit 
      ? 'http://priyanthabandara.lk/update_quotation.php'
      : 'http://priyanthabandara.lk/save_quotation.php';

    // Enhanced fetch with timeout and better error handling
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

    const saveResponse = await fetch(endpoint, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(saveData),
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);

    // Handle non-2xx responses
    if (!saveResponse.ok) {
      let errorData;
      try {
        errorData = await saveResponse.json();
      } catch (e) {
        errorData = { error: `HTTP error ${saveResponse.status}: ${saveResponse.statusText}` };
      }
      throw new Error(errorData.error || 'Failed to save quotation');
    }

    const saveResult = await saveResponse.json();
    
    if (!saveResult.success) {
      throw new Error(saveResult.error || 'Save operation failed');
    }
    
    // Update UI state first
    setFormData(prev => ({
      ...prev,
      quotationNumber: saveData.quotationNumber,
      filename: saveData.filename
    }));

    // Send payment confirmation SMS after successful save
    await sendPaymentConfirmationSMS(saveData);
    
    // Success feedback
    alert(`Quotation ${saveData.quotationNumber} ${isEdit ? 'updated' : 'saved'} successfully!`);
    return saveResult;
    
  } catch (error) {
    console.error('Save error:', error);
    let errorMessage = error.message;
    
    // Handle specific error cases
    if (error.name === 'AbortError') {
      errorMessage = 'Request timed out. Please try again.';
    } else if (error.message.includes('Failed to fetch')) {
      errorMessage = 'Network error. Please check your connection.';
    }
    
    alert(`Error: ${errorMessage}`);
    throw error;
  }
};

const sendPaymentConfirmationSMS = async (quotationData) => {
  try {
    // Track if we've sent any SMS to avoid duplicate sends
    let smsSent = false;

    // Check for active payments first
    if (quotationData.payments?.length > 0) {
      // Find the first active payment that was received
      const activePayment = quotationData.payments.find(
        payment => payment.received && payment.amount && payment.active
      );
      
      if (activePayment) {
        const smsText = `Dear ${quotationData.customerName},\nWe have received your payment of LKR ${activePayment.amount} (${activePayment.description || ''}) for quotation ${quotationData.quotationNumber}.\nThank you! - Priyantha Bandara Photography`;
        await sendSMS(quotationData.mobileNo, smsText);
        smsSent = true;
      }
    }
    
    // Only check advance payment if no payment SMS was sent
    if (!smsSent && quotationData.advanceReceived && quotationData.advance) {
      const smsText = `Dear ${quotationData.customerName},\nWe have received your advance payment of LKR ${quotationData.advance} for quotation ${quotationData.quotationNumber}.\nThank you! - Priyantha Bandara Photography`;
      await sendSMS(quotationData.mobileNo, smsText);
    }
  } catch (error) {
    console.error('Error sending SMS:', error);
    // Optionally show user feedback
    alert('Payment was saved but SMS notification failed');
  }
};



const sendSMS = async (phoneNumber, message) => {
  try {
    const response = await fetch('http://priyanthabandara.lk/eSMS/send_sms.php', {
      method: 'POST',
      mode: 'cors', // explicitly request CORS
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        phoneNumber: phoneNumber,
        message: message
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('SMS sending error:', error);
    // Show user-friendly error message
    alert(`Failed to send SMS: ${error.message}`);
    throw error;
  }
};

  const handlePackageOptionChange = (option) => {
    setFormData(prev => ({
      ...prev,
      packageOptions: {
        ...prev.packageOptions,
        [option]: !prev.packageOptions[option]
      }
    }));
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @page { size: A4; margin: 10mm; }
      @media print {
        .no-print { display: none !important; }
      }
    `,
  });

  const handleDownloadPDF = async () => {
    const input = componentRef.current;
    const buttons = input.querySelectorAll('.no-print');
    
    buttons.forEach(button => button.style.visibility = 'hidden');
    
    try {
      const canvas = await html2canvas(input, {
        scale: 2,
        logging: false,
        useCORS: true,
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`${formData.customerName || 'quotation'}_${formData.quotationNumber}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      buttons.forEach(button => button.style.visibility = 'visible');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      const [section, field] = name.split(".");
      setFormData(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: checked,
        },
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

const calculateBalance = () => {
  const subtotal = Number(formData.total || 0) - Number(formData.discount || 0);
  const totalPaid = Number(formData.advance || 0) + 
                   (formData.payments?.reduce((sum, payment) => sum + Number(payment.amount || 0), 0) || 0);
  return (subtotal - totalPaid).toFixed(2);
};
  const handleSubmit = (e) => {
    e.preventDefault();
    setShowQuotation(true);
  };




  const EditablePackageSection = ({ 
  packageName, 
  features, 
  onUpdatePackage,
  onAddFeature,
  onRemoveFeature,
  onUpdateFeature
}) => {
  const [newFeature, setNewFeature] = useState('');

  return (
    <div className="editable-package">
      <h3>{packageName}</h3>
      <ul className="editable-feature-list">
        {features.map((feature, index) => (
          <li key={index} className="editable-feature-item">
            <input
              type="text"
              value={feature}
              onChange={(e) => onUpdateFeature(packageName, index, e.target.value)}
              className="editable-feature-input"
            />
            <button
              type="button"
              className="remove-feature-btn"
              onClick={() => onRemoveFeature(packageName, index)}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
      <div className="add-feature-container">
        <input
          type="text"
          value={newFeature}
          onChange={(e) => setNewFeature(e.target.value)}
          placeholder="Add new feature"
          className="add-feature-input"
        />
        <button
          type="button"
          className="add-feature-btn"
          onClick={() => {
            if (newFeature.trim()) {
              onAddFeature(packageName, newFeature);
              setNewFeature('');
            }
          }}
        >
          Add
        </button>
      </div>
    </div>
  );
};



  

  return (
    <div className={`quotation-maker-container `}>
      <div className="app-header">
        <h1 className="quotation-title">
          <SiReact className="icon" /> Wedding Quotation Maker
        </h1>
        
      </div>

      <div className="form-navigation">
        <button 
          className={`nav-btn ${activeTab === 'details' ? 'active' : ''}`}
          onClick={() => setActiveTab('details')}
        >
          <FiUser className="icon" /> Client Details
        </button>
        <button 
          className={`nav-btn ${activeTab === 'package' ? 'active' : ''}`}
          onClick={() => setActiveTab('package')}
        >
          <FiCalendar className="icon" /> Package
        </button>
        <button 
          className={`nav-btn ${activeTab === 'setup' ? 'active' : ''}`}
          onClick={() => setActiveTab('setup')}
        >
          <FiMapPin className="icon" /> Setup
        </button>
        <button 
          className={`nav-btn ${activeTab === 'payment' ? 'active' : ''}`}
          onClick={() => setActiveTab('payment')}
        >
          <SiReact className="icon" /> Payment
        </button>
      </div>

      <form className="quotation-form" onSubmit={handleSubmit}>
        {/* Client Details Section */}
        <div className={`form-section ${activeTab === 'details' ? 'active' : ''}`}>
          <div className="section-card">
            <h2 className="section-title">
              <FiUser className="icon" /> Client Information
            </h2>
            
            <div className="form-grid">
              <div className="input-group">
                <label>
                  <FiUser className="input-icon" /> Customer Name
                </label>
                <input
                  type="text"
                  name="customerName"
                  value={formData.customerName}
                  onChange={handleChange}
                  required
                  className="premium-input"
                />
              </div>
              
              <div className="input-group">
                <label>
                  <FiHome className="input-icon" /> Address
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  className="premium-input"
                />
              </div>
              
              <div className="input-group">
                <label>
                  <FiPhone className="input-icon" /> Telephone No
                </label>
                <input
                  type="tel"
                  name="telephoneNo"
                  value={formData.telephoneNo}
                  onChange={handleChange}
                  required
                  className="premium-input"
                  placeholder="e.g. 011xxxxxxx"
                  pattern="[0-9]{3}[0-9]{7,8}"
                />
              </div>
              
              <div className="input-group">
                <label>
                  <FiSmartphone className="input-icon" /> Mobile No
                </label>
                <input
                  type="tel"
                  name="mobileNo"
                  value={formData.mobileNo}
                  onChange={handleChange}
                  required
                  className="premium-input"
                  placeholder="e.g. 07xxxxxxxx"
                  pattern="[0-9]{3}[0-9]{7,8}"
                />
              </div>
              
              <div className="input-group">
                <label>
                  <FiMail className="input-icon" /> Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="premium-input"
                />
              </div>
            </div>
          </div>

          <div className="section-card">
            <h2 className="section-title">
              <FiCalendar className="icon" /> Event Dates
            </h2>
            
            <div className="form-grid">
              <div className="input-group">
                <label>Wedding Date</label>
                <div className="date-input-wrapper">
                  <FiCalendar className="date-icon" />
                  <input
                    type="date"
                    name="weddingDate"
                    value={formData.weddingDate}
                    onChange={handleChange}
                    required
                    className="premium-input"
                  />
                </div>
              </div>
              
              <div className="input-group">
                <label>Wedding Location</label>
                <div className="location-input-wrapper">
                  <FiMapPin className="location-icon" />
                  <input
                    type="text"
                    name="WeddingLocation"
                    value={formData.WeddingLocation}
                    onChange={handleChange}
                    className="premium-input"
                  />
                </div>
              </div>
              
              <div className="input-group">
                <label>Homecoming Date</label>
                <div className="date-input-wrapper">
                  <FiCalendar className="date-icon" />
                  <input
                    type="date"
                    name="homecomingDate"
                    value={formData.homecomingDate}
                    onChange={handleChange}
                    className="premium-input"
                  />
                </div>
              </div>
              
              <div className="input-group">
                <label>Homecoming Location</label>
                <div className="location-input-wrapper">
                  <FiMapPin className="location-icon" />
                  <input
                    type="text"
                    name="homecomingLocation"
                    value={formData.homecomingLocation}
                    onChange={handleChange}
                    className="premium-input"
                  />
                </div>
              </div>
              
              <div className="input-group">
                <label>Preshoot Date</label>
                <div className="date-input-wrapper">
                  <FiCalendar className="date-icon" />
                  <input
                    type="date"
                    name="preshootDate"
                    value={formData.preshootDate}
                    onChange={handleChange}
                    className="premium-input"
                  />
                </div>
              </div>
              
              <div className="input-group">
                <label>Preshoot Location</label>
                <div className="location-input-wrapper">
                  <FiMapPin className="location-icon" />
                  <input
                    type="text"
                    name="preshootLocation"
                    value={formData.preshootLocation}
                    onChange={handleChange}
                    className="premium-input"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Package Section */}
        {/* Package Section */}
{/* Package Section */}
<div className={`form-section ${activeTab === 'package' ? 'active' : ''}`}>
  <div className="section-card package-selection">
    <h2 className="section-title">
      <SiReact className="icon" /> Package Selection
    </h2>
    
    <div className="package-tabs">
      {Object.keys(formData.editablePackages).map((pkg) => (
        <button
          key={pkg}
          type="button"
          className={`package-tab ${formData.packageSelected === pkg ? 'active' : ''}`}
          onClick={() => setFormData({...formData, packageSelected: pkg})}
        >
          {pkg}
        </button>
      ))}
    </div>
    
    <div className="package-features">
      <h3>{formData.packageSelected} Features</h3>
      <ul className="feature-list">
        {formData.editablePackages[formData.packageSelected]?.map((feature, index) => (
          <li key={index} className="feature-item">
            <div className="feature-controls">
              <input
                type="checkbox"
                checked={formData.packageOptions[feature] || false}
                onChange={() => handlePackageOptionChange(feature)}
                className="feature-checkbox"
              />
              <input
                type="text"
                value={feature}
                onChange={(e) => {
                  if (formData.packageOptions[feature]) {
                    alert('Please uncheck the checkbox before editing this feature');
                    return;
                  }
                  const updatedPackages = {...formData.editablePackages};
                  updatedPackages[formData.packageSelected][index] = e.target.value;
                  setFormData({...formData, editablePackages: updatedPackages});
                }}
                className="feature-input"
                disabled={formData.packageOptions[feature]}
                title={formData.packageOptions[feature] ? "Uncheck the box to edit this feature" : ""}
              />
              <button
                type="button"
                className="remove-feature-btn"
                onClick={() => {
                  if (formData.packageOptions[feature]) {
                    alert('Please uncheck the checkbox before removing this feature');
                    return;
                  }
                  const updatedPackages = {...formData.editablePackages};
                  updatedPackages[formData.packageSelected] = updatedPackages[formData.packageSelected]
                    .filter((_, i) => i !== index);
                  setFormData({...formData, editablePackages: updatedPackages});
                }}
                disabled={formData.packageOptions[feature]}
                title={formData.packageOptions[feature] ? "Uncheck the box to remove this feature" : ""}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
              </button>
            </div>
          </li>
        ))}
      </ul>
      
    </div>

    <div className="add-feature-container">
            <input
              type="text"
              placeholder="Add new feature..."
              className="add-feature-input"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && e.target.value.trim()) {
                  const updatedPackages = {...formData.editablePackages};
                  updatedPackages[formData.packageSelected] = [
                    ...updatedPackages[formData.packageSelected],
                    e.target.value.trim()
                  ];
                  setFormData({...formData, editablePackages: updatedPackages});
                  e.target.value = '';
                }
              }}
            />
            <button
              type="button"
              className="add-feature-btn"
              onClick={(e) => {
                const input = e.target.previousElementSibling;
                if (input.value.trim()) {
                  const updatedPackages = {...formData.editablePackages};
                  updatedPackages[formData.packageSelected] = [
                    ...updatedPackages[formData.packageSelected],
                    input.value.trim()
                  ];
                  setFormData({...formData, editablePackages: updatedPackages});
                  input.value = '';
                }
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg> Add Feature
            </button>
          </div>
    
    <div className="additional-notes">
      <label>Additional Notes</label>
      <textarea
        name="additionalDetails"
        value={formData.additionalDetails}
        onChange={handleChange}
        placeholder="Any special requests or additional details"
        className="premium-textarea"
      ></textarea>
    </div>
  </div>
</div>

        {/* Setup Section */}
        <div className={`form-section ${activeTab === 'setup' ? 'active' : ''}`}>
          <div className="setup-grid">
            <div className="setup-card">
              <h3 className="setup-title">Homecoming Options</h3>
              <div className="checkbox-group">
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="homecomingOptions.shootOnly"
                    checked={formData.homecomingOptions.shootOnly}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  Shoot Only
                </label>
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="homecomingOptions.shootFunction"
                    checked={formData.homecomingOptions.shootFunction}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  Shoot and Function
                </label>
              </div>
            </div>
            
            <div className="setup-card">
              <h3 className="setup-title">Photography Setup</h3>
              <div className="checkbox-group">
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="photographySetup.camera1"
                    checked={formData.photographySetup.camera1}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  1 Camera coverage
                </label>
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="photographySetup.camera2"
                    checked={formData.photographySetup.camera2}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  2 Cameras coverage
                </label>
              </div>
            </div>
            
            <div className="setup-card">
              <h3 className="setup-title">Cinematography Setup</h3>
              <div className="checkbox-group">
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="cinematographySetup.camera1"
                    checked={formData.cinematographySetup.camera1}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  1 Camera coverage
                </label>
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="cinematographySetup.camera2"
                    checked={formData.cinematographySetup.camera2}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  2 Cameras coverage
                </label>
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="cinematographySetup.drone"
                    checked={formData.cinematographySetup.drone}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  Drone
                </label>
              </div>
            </div>
            
            <div className="setup-card">
              <h3 className="setup-title">Preshoot Setup</h3>
              <div className="checkbox-group">
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="preshootSetup.camera1"
                    checked={formData.preshootSetup.camera1}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  1 Camera coverage
                </label>
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="preshootSetup.camera2"
                    checked={formData.preshootSetup.camera2}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  2 Cameras coverage
                </label>
                <label className="premium-checkbox">
                  <input
                    type="checkbox"
                    name="preshootSetup.drone"
                    checked={formData.preshootSetup.drone}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  Drone
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Payment Section */}
        <div className={`form-section ${activeTab === 'payment' ? 'active' : ''}`}>
  <div className="section-card payment-card">
    <h2 className="section-title">Payment Details</h2>
    
    <div className="payment-grid">
      {/* Total Amount */}
      <div className="payment-input">
        <label>Total Amount (LKR)</label>
        <div className="payment-input-wrapper">
          <input
            type="number"
            name="total"
            value={formData.total}
            onChange={handleChange}
            required
            className="premium-input"
          />
        </div>
      </div>
      
      {/* Discount Field */}
      <div className="payment-input">
        <label>Discount (LKR)</label>
        <div className="payment-input-wrapper">
          <input
            type="number"
            name="discount"
            value={formData.discount || ''}
            onChange={handleChange}
            className="premium-input"
          />
        </div>
      </div>

       {/* NEW: Advance Payment Field */}
      <div className="payment-input">
        <label>Advance Payment (LKR)</label>
        <div className="payment-input-wrapper">
          <input
            type="number"
            name="advance"
            value={formData.advance || ''}
            onChange={handleChange}
            className="premium-input"
          />
        </div>
      </div>
      {/* In the Payment Section, after the advance payment date field */}
{/* In the Payment Section, after the advance payment date field */}
<div className="payment-input">
  <label className="premium-checkbox">
    <input
      type="checkbox"
      name="advanceReceived"
      checked={formData.advanceReceived || false}
      onChange={(e) => {
        setFormData(prev => ({
          ...prev,
          advanceReceived: e.target.checked
        }));
      }}
      disabled={formData.payments?.length > 0} // Disable if any payments exist
    />
    <span className="checkmark"></span>
    Payment Received
  </label>
</div>
{/* NEW: Advance Payment Date */}
      <div className="payment-input">
        <label>Advance Payment Date</label>
        <input
          type="date"
          name="advanceDate"
          value={formData.advanceDate || ''}
          onChange={handleChange}
          className="premium-input"
        />
      </div>
      
      {/* Subtotal After Discount */}
      <div className="payment-input">
        <label>Subtotal (LKR)</label>
        <div className="balance-display">
          {formData.total && formData.discount ? (
            <span className="balance-amount">
              {Number(formData.total) - Number(formData.discount || 0) - Number(formData.advance || 0)}
            </span>
          ) : (
            <span className="balance-placeholder">-</span>
          )}
        </div>
      </div>
      
      {/* Balance Display */}
      <div className="payment-input">
        <label>Balance (LKR)</label>
        <div className="balance-display">
          {calculateBalance() ? (
            <span className="balance-amount">
              {calculateBalance()}
            </span>
          ) : (
            <span className="balance-placeholder">-</span>
          )}
        </div>
      </div>
    </div>
    
    {/* Payment Parts Section */}
    <div className="payment-parts-section">
  <div className="section-header">
    <h3>Payment Schedule</h3>
    <button 
      type="button" 
      className="add-payment-btn"
      onClick={() => {
        const newPayments = [...(formData.payments || [])];
        
        // Disable and uncheck all existing payments
        newPayments.forEach(p => {
          p.active = false;
          p.received = false;
        });
        
        // Add new active payment
        newPayments.push({ 
          amount: '', 
          date: '', 
          description: '', 
          received: false, 
          active: true 
        });
        
        setFormData(prev => ({
          ...prev,
          payments: newPayments,
          advanceReceived: false
        }));
      }}
    >
      + Add Payment
    </button>
  </div>
  
  {formData.payments?.map((payment, index) => (
    <div key={index} className="payment-part">
      <div className="payment-part-header">
        <h4>Payment {index + 1}</h4>
        {index > 0 && (
          <button
            type="button"
            className="remove-payment-btn"
            onClick={() => {
              const newPayments = [...formData.payments];
              newPayments.splice(index, 1);
              setFormData(prev => ({
                ...prev,
                payments: newPayments
              }));
            }}
          >
            Remove
          </button>
        )}
      </div>
      
      <div className="payment-part-grid">
        <div className="payment-input">
          <label>Amount (LKR)</label>
          <input
            type="number"
            value={payment.amount}
            onChange={(e) => {
              const newPayments = [...formData.payments];
              newPayments[index].amount = e.target.value;
              setFormData(prev => ({
                ...prev,
                payments: newPayments
              }));
            }}
            className="premium-input"
          />
        </div>

        <div className="payment-input">
          <label className="premium-checkbox">
            <input
              type="checkbox"
              checked={payment.received || false}
              onChange={(e) => {
                const newPayments = [...formData.payments];
                newPayments[index].received = e.target.checked;
                setFormData(prev => ({
                  ...prev,
                  payments: newPayments
                }));
              }}
              disabled={!payment.active}
              className="premium-input"
            />
            <span className="checkmark"></span>
            Payment Received
          </label>
        </div>
        
        <div className="payment-input">
          <label>Payment Date</label>
          <input
            type="date"
            value={payment.date}
            onChange={(e) => {
              const newPayments = [...formData.payments];
              newPayments[index].date = e.target.value;
              setFormData(prev => ({
                ...prev,
                payments: newPayments
              }));
            }}
            className="premium-input"
          />
        </div>
        
        <div className="payment-input full-width">
          <label>Description</label>
          <input
            type="text"
            value={payment.description}
            onChange={(e) => {
              const newPayments = [...formData.payments];
              newPayments[index].description = e.target.value;
              setFormData(prev => ({
                ...prev,
                payments: newPayments
              }));
            }}
            placeholder="E.g.: 50% advance, Final payment, etc."
            className="premium-input"
          />
        </div>
      </div>
    </div>
  ))}
</div>
  </div>
</div>

        <div className="form-actions">
          <button type="submit" className="generate-btn">
            <FiPrinter className="btn-icon" /> Generate Quotation
          </button>
          
          {showQuotation && (
            <div className="quotation-actions">
              <button 
                type="button" 
                className="action-btn pdf-btn"
                onClick={handleDownloadPDF}
              >
                <FiDownload className="btn-icon" /> Save as PDF
              </button>
              
              <button 
                type="button" 
                className="action-btn save-btn"
                onClick={handleSaveToServer}
              >
                <FiSave className="btn-icon" /> Save to Server
              </button>
            </div>
          )}
        </div>
      </form>

      {/* Generated Quotation */}
      {showQuotation && (
        <PBQuot 
          ref={componentRef}
          formData={formData}
          balance={calculateBalance()}
        />
      )}
    </div>
  );
}

export default QuotationMaker; 